<template>
  <section>
    <b-modal :active.sync="isModalEditScenario" :can-cancel="false">
      <ScenarioEditor />
    </b-modal>
  </section>
</template>

<script>
import { mapState }    from 'vuex'
import ScenarioEditor  from '@/components2/Robo/modal/organisms/ScenarioEditor'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'ModalEditScenario',
  components: {
    ScenarioEditor,
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['isModalEditScenario']),
  }
}
</script>

<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalEditScenario.vue